import { render, staticRenderFns } from "./GlobalAppBar.vue?vue&type=template&id=5b5fcfa4"
import script from "./GlobalAppBar.vue?vue&type=script&lang=js"
export * from "./GlobalAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports